export function bindMasterDataClick(target: EventTarget, listener: (event: MouseEvent) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("click", listener as EventListener);
}

export function bindMasterDataSubmit(target: EventTarget, listener: (event: SubmitEvent) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("submit", listener as EventListener);
}

export function bindMasterDataInput(target: EventTarget, listener: (event: Event) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("input", listener as EventListener);
}

export function bindMasterDataBlur(target: EventTarget, listener: (event: FocusEvent) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("blur", listener as EventListener);
}

export function bindMasterDataChange(target: EventTarget, listener: (event: Event) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("change", listener as EventListener);
}

export function bindMasterDataKeydown(target: EventTarget, listener: (event: KeyboardEvent) => void): void {
    if (!(target instanceof EventTarget)) return;
    target.addEventListener("keydown", listener as EventListener);
}
